// Copyright (c) 2022 by Move Closer

import { Country } from '../../../../contexts'
import { CountryData } from '../../../shared/services/dictionary'
import { ValidationRules } from '../../../shared/molecules/Form'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const changeAddressFormValidators: ValidationRules = {
  company: 'filled|string|min:2',
  countryCode: 'required|string|min:2',
  city: 'required|string|min:3',
  firstName: 'required|string|min:3',
  lastName: 'required|string|min:3',
  postalCode: 'required|string|min:5|max:7',
  phoneNumber: 'required|string|min:9|max:14',
  street: 'required|string|min:3'
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const translateCountryToCountrySelectOption = (countries: CountryData[]): Array<Country> => {
  return countries.map(country => {
    return {
      label: country.fullNameLocale,
      code: country.id
    }
  })
}
